import { FunctionComponent, memo } from 'react';
import { StoryCardArticleContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedAdminCardWrapper } from '../HorizontalStoryFeedAdminCardWrapper';

export const HorizontalStoryFeedAdminArticle: FunctionComponent<HorizontalStoryFeedCardProps> =
  memo(({ card }) => {
    const { type, content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;
    const { title, sourceName, abstract } = content as StoryCardArticleContent;

    return (
      <HorizontalStoryFeedAdminCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          cardType={type}
          source={sourceName}
          title={title}
          text={abstract}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedAdminCardWrapper>
    );
  });
